export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              type: 'div',
              name: "Seção Numeros",
              attributes: { class: 'section bg-cinza' },
              components: [
                {
                  type: 'containerNumbers8',
                },
      
              ],
              styles: `
             .section{
               position:relative; 
               with:100vw; 
               padding: 75px 5%; 
             }
             .bg-cinza{
                background: #F7F7F7;
             }
             *{
              font-family: Roboto, Arial, sans-serif;
            }
            `,
            },
          },
          view: {
      
          },
};
  return component; 
};